import { render, staticRenderFns } from "./PurchasedMerchantRewardsReport.vue?vue&type=template&id=37b25074&"
import script from "./PurchasedMerchantRewardsReport.vue?vue&type=script&lang=js&"
export * from "./PurchasedMerchantRewardsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports